export default __webpack_public_path__ + "static/media/21.54d5d686.mp3";